import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  .container {
    padding: 15px;
  }

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }

  .info-description {
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
  }

  .empty-state {
    display: flex;
    justify-content: center;
    padding: 2rem;
    color: var(--sl-color-neutral-600);
    font-size: 0.9rem;
  }

  .data-table-container {
    overflow-x: auto;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
  }

  .data-table th,
  .data-table td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid var(--sl-color-neutral-200);
  }

  .data-table th {
    font-weight: 600;
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
    background: var(--sl-color-neutral-50);
  }

  .data-table td {
    color: var(--sl-color-neutral-900);
    font-size: 0.875rem;
  }

  .clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .clickable-row:hover {
    background-color: var(--sl-color-neutral-50);
  }

  .status-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
  }

  .status-badge.active {
    background: var(--sl-color-success-100);
    color: var(--sl-color-success-700);
  }

  .status-badge.inactive {
    background: var(--sl-color-neutral-200);
    color: var(--sl-color-neutral-600);
  }
`;

